export default "__VITE_PUBLIC_ASSET__7437576e__"